import React from 'react';
import { Lock, Zap, Shield, CreditCard } from 'lucide-react';
export function Footer() {
  const trustItems = [{
    icon: Lock,
    text: 'Pago 100% seguro'
  }, {
    icon: Zap,
    text: 'Acceso en 5 minutos'
  }, {
    icon: Shield,
    text: 'Garantía 7 días'
  }, {
    icon: CreditCard,
    text: 'Mercado Pago · Tarjeta · Transferencia'
  }];
  return <footer className="bg-noche border-t border-petroleoLight pt-16 pb-8 px-6" data-id="element-142">
      <div className="max-w-6xl mx-auto" data-id="element-143">
        {/* Trust Row */}
        <div className="flex flex-wrap justify-center gap-6 md:gap-12 mb-16 pb-12 border-b border-petroleoLight/50" data-id="element-144">
          {trustItems.map((item, idx) => <div key={idx} className="flex items-center gap-2 text-gray-300" data-id="element-145">
              <item.icon className="w-5 h-5 text-tealBrand" data-id="element-146" />
              <span className="text-sm font-medium" data-id="element-147">{item.text}</span>
            </div>)}
        </div>

        {/* Main Footer Content */}
        <div className="text-center max-w-2xl mx-auto mb-12" data-id="element-148">
          <div className="text-2xl font-bold text-tealBrand mb-4" data-id="element-149">
            🏫 BIBLIOTECAS DIGITALES™
          </div>
          <p className="text-gray-400 mb-8" data-id="element-150">
            El sistema de recursos N°1 para docentes argentinos. Porque enseñar
            no debería costarte todos los domingos del año.
          </p>

          <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-8 text-sm text-gray-300" data-id="element-151">
            <a href="mailto:soportebibliotecasdigitales@gmail.com" className="hover:text-tealBrand transition-colors" data-id="element-152">
              📧 soportebibliotecasdigitales@gmail.com
            </a>
            <a href="https://www.bibliotecasdigitales.store" target="_blank" rel="noreferrer" className="hover:text-tealBrand transition-colors" data-id="element-153">
              🌐 www.bibliotecasdigitales.store
            </a>
          </div>
        </div>

        {/* Copyright & Closing */}
        <div className="text-center text-sm text-gray-500 flex flex-col gap-4" data-id="element-154">
          <p data-id="element-155">
            © Bibliotecas Digitales™ 2025 — Todos los derechos reservados.
          </p>
          <p className="text-tealBrand/70 font-medium" data-id="element-156">
            🏫 "La próxima clase puede ser la mejor que diste."
          </p>
        </div>
      </div>
    </footer>;
}